import request from './request';

export default {
	async getScanHistory(query) {
		const response = await request.get('/app/scan-receipts', query);
		return response;
	}
};
